const language = {
    'pt':
    {
        add_new: 'Solicitar Reparação',
        cancel: 'Cancelar', back: 'Voltar',
        component: 'Reparação',
        component_new: 'Nova Reparação',
        component_edit: 'Editar Reparação',
        component_list: 'Lista de Reparações',
        close: 'Fechar',
        color: 'Cor',
        color_placeholder: 'Introduza a cor',
        color_primary: 'Cor Primária',
        color_secondary: 'Cor Secundária ',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao atualizar registo!',
        edit_success: 'Registo atualizado com sucesso!',

        field_active_type: 'Tipo de Reparação',
        field_active_type_placeholder: 'Introduza o tipo de Reparação',
        field_equip_state: 'Estado do Equipamento',
        field_equip_state_placeholder: 'Introduza o estado do equipamento',
        field_activo: 'Reparação?',
        field_visivel: 'Visível?',
        field_avaiable: 'Disponível?',
        field_choose: 'Escolha uma opção',
        field_category: 'Categoria',
        field_category_placeholder: 'Introduza a categoria',
        field_observation: 'Observação',
        field_observation_placeholder: 'Introduza uma observação',
        field_abreviation: 'Abreviatura',
        field_abreviation_placeholder: 'Introduza a abreviação',
        field_adultos: 'Adultos',
        field_adultos_placeholder: 'Introduza o número de adultos',
        field_criancas: 'Crianças',
        field_criancas_placeholder: 'Introduza o número de crianças',
        field_description: 'Descrição',
        field_description_placeholder: 'Introduza a descrição',
        field_forfait: 'Forfait',
        field_forfait_price: 'Preço do Forfait',
        field_forfait_price_placeholder: 'Introduza o preço do Forfait',
        field_forfait_taxe: 'IVA do Forfait',
        field_forfait_taxe_placeholder: 'Introduza o IVA do Forfait',
        field_equipamento: 'Equipamento',
        field_equipamento_price: 'Preço do Equipamento',
        field_equipamento_price_placeholder: 'Introduza o preço do Equipamento',
        field_equipamento_taxe: 'IVA do Equipamento',
        field_equipamento_taxe_placeholder: 'Introduza o IVA do Equipamento',
        field_final_price: 'Preço Final',
        field_final_price_palceholder: 'Introduza o Preço Final',
        field_price: 'Preço',
        field_price_since: 'Preço desde',
        field_name: 'Identidicação do Equipamento',
        field_name_placeholder: 'Introduza a Identificação do Equipamento',
        field_document_type: 'Tipo de Documento',
        field_status: 'Estado',
        field_comprimento: 'Comprimento',
        field_comprimento_placeholder: 'Inserir comprimento',
        field_dificuldade: 'Dificuldade',
        field_dificuldade_placeholder: 'Inserir dificuldade',
        field_desnivel: 'Desnível (m)',
        field_desnivel_placeholder: 'Inserir desnível (m)',
        field_type: 'Tipo',
        field_duracao: 'Duração',
        field_person: 'Afetação de técnicos',
        field_appointment: 'Afetação de recursos',

        field_tag: 'Código',
        field_tag_placeholder: 'Inserir o código',
        field_codigo: 'Código',
        field_identificacao: 'Identificação',
        field_marca: 'Marca',
        field_modelo: 'Modelo',
        field_numero_serie: 'Nº Série',
        field_storage_fab_year: 'Ano de Fabrico',
        field_storage_type: 'Formato de Armazenamento',
        field_storage_local: 'Local de Armazenamento',
        field_storage_supply: 'Fornecedor',
        field_storage_serie: 'Séries',
        field_storage_serie_placeholder: 'Introduza o Número de Série',
        field_storage_location: 'Localização',
        field_storage_description: 'Descrição',
        field_storage_date: 'Data de Armazenamento',
        field_retention_time: 'Tempo de retenção',
        field_state: 'Estado',
        field_version: 'Versão',

        field_det_responsable: 'Responsável Deteção',
        field_det_responsable_date: 'Data de Deteção',
        field_equipamento: 'Equipamento',
        field_details: 'Detalhes do Equipamento',
        field_id: 'Codigo do Equipamento',
        field_label: 'Etiqueta do Equipamento',
        field_cod: 'Código do Equipamento',
        field_brand: 'Marca do Equipamento',
        field_model: 'Modelo do Equipamento',
        field_serie: 'Número de Série do Equipamento',
        field_local: 'Local de Armazenamento',
        field_det_date: 'Data de Deteção',
        problem_description: 'Descrição do Problema',
        problem_loc: 'Local do Problema',

        field_aprovation_date: 'Data de aprovação',
        field_aprovation_name: 'Nome do responsável pela aprovação',
        field_edition_date: 'Data de edição',
        field_edition_name: 'Nome do responsável pela edição',
        field_storage_brand: 'Marca',
        field_storage_brand_placeholder: 'Introduza a Marca',
        field_storage_model: 'Modelo',
        field_storage_model_placeholder: 'Introduza o Modelo',

        foto: 'Foto',
        upload_foto: 'Carregar Foto',
        foto_empty: 'Sem Foto',
        filter_placeholder: 'Procurar',
        id: 'ID',
        image: 'Imagem',
        images: 'Imagens',
        image_choose: 'Escolher imagem',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        principal: 'Principal',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_color: 'Cores',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'sem resultados',
        save: 'Salvar',
        upload_image_error: 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n',
        youtube_choose: 'Youtube',
        upload_file_error: 'O ficheiro tem mais de 10MB.',
        editable_documents: 'Documento editável',
        pdf_documents: 'Documentos PDF',
        doc_choose: 'Carregar documento',
        field_edit_responsable: 'Responsável de Edição',
        field_aproval_responsable: 'Responsável de Aprovação',
        field_remove_responsable: 'Responsável de Eliminação',
        field_choose_responsable: 'Escolha um responsável',
        field_document_state: 'Estado do documento',
        field_aproval: 'Aprovar',

        notification_aproval_subject: 'Solicitação de aprovação de documento',
        notification_aproval_text: 'Tem uma solicitação para aprovação de um documento. Entre na plataforma para dar seguimento ao pedido.',

        informacao_financeira: 'Informação Financeira',
        ano_de_aquisicao: 'Ano de Aquisição',
        ano_de_aquisicao_placeholder: 'Introduza o ano de aquisição',
        valor_de_aquisicao: 'Valor de Aquisição',
        valor_de_aquisicao_placeholder: 'Introduza o valor de aquisição',
        data_fim_de_garantia: 'Data Fim de Garantia',
        data_fim_de_vida: 'Data Fim de Vida',
        tipo_manutencao: 'Tipo de Manutenção',
        field_data_inicio: 'Data de Início',
        field_deadline: 'Data Limite',
    },
    'en':
    {
       photo: 'Photo',
upload_photo: 'Upload Photo',
photo_empty: 'No Photo',
add_new: 'Add new',
calendar: 'Calendar',
cancel: 'Cancel',
component: 'Repair',
component_new: 'New Repair',
component_edit: 'Edit Repair',
component_list: 'Repair List',
close: 'Close',
color: 'Color',
color_placeholder: 'Insert the color',
color_primary: 'Primary Color',
color_secondary: 'Secondary Color',
delete: 'Delete',
delete_title: 'Delete Record',
delete_text: 'Are you sure you want to continue?',
delete_confirm: 'Yes',
delete_cancel: 'No',
delete_error: 'Problem deleting the record!',
delete_success: 'Record deleted successfully!',
edit: 'Edit',
edit_title: 'Edit Record',
edit_text: 'Are you sure you want to continue?',
edit_confirm: 'Yes',
edit_cancel: 'No',
edit_error: 'Problem updating record!',
edit_success: 'Record updated successfully!',
field_activo: 'Repair?',
field_visivel: 'Visible?',
field_avaiable: 'Available?',
field_choose: 'Choose an option',
field_category: 'Category',
field_category_placeholder: 'Enter the category',
field_observation: 'Observation',
field_observation_placeholder: 'Enter an observation',
field_abreviation: 'Abbreviation',
field_abreviation_placeholder: 'Enter the abbreviation',
field_adultos: 'Adults',
field_adultos_placeholder: 'Enter the number of adults',
field_criancas: 'Children',
field_criancas_placeholder: 'Enter the number of children',
field_description: 'Description',
field_description_placeholder: 'Enter the description',
field_forfait: 'Package',
field_forfait_price: 'Package Price',
field_forfait_price_placeholder: 'Enter the package price',
field_forfait_taxe: 'Package VAT',
field_forfait_taxe_placeholder: 'Enter the package VAT',
field_equipamento: 'Equipment',
field_equipamento_price: 'Equipment Price',
field_equipamento_price_placeholder: 'Enter the equipment price',
field_equipamento_taxe: 'Equipment VAT',
field_equipamento_taxe_placeholder: 'Enter the equipment VAT',
field_final_price: 'Final Price',
field_final_price_palceholder: 'Enter the Final Price',
field_price: 'Price',
field_price_since: 'Price since',
field_name: 'Document Identification',
field_name_placeholder: 'Enter the document identification',
field_name: 'Name',
field_name_placeholder: 'Enter the name',
field_document_type: 'Document Type',
field_status: 'Status',
field_comprimento: 'Length',
field_comprimento_placeholder: 'Enter length',
field_dificuldade: 'Difficulty',
field_dificuldade_placeholder: 'Enter difficulty',
field_desnivel: 'Slope (m)',
field_desnivel_placeholder: 'Enter slope (m)',
field_type: 'Type',
field_duracao: 'Duration',
field_person: 'Technician allocation',
field_appointment: 'Resource allocation',
field_tag: 'Code',
field_tag_placeholder: 'Enter the code',
field_storage_type: 'Storage Format',
field_storage_local: 'Storage Location',
field_retention_time: 'Retention Time',
field_state: 'Status',
field_version: 'Version',
field_aprovation_date: 'Approval Date',
field_aprovation_name: 'Approval Responsible Name',
field_edition_date: 'Edition Date',
field_edition_name: 'Edition Responsible Name',
filter_placeholder: 'Search',
id: 'ID',
image: 'Image',
images: 'Images',
image_choose: 'Choose image',
insert_title: 'New Record',
insert_text: 'Are you sure you want to continue?',
insert_confirm: 'Yes',
insert_cancel: 'No',
insert_error: 'Problem inserting record!',
insert_success: 'Record inserted successfully!',
principal: 'Main',
remove: 'Remove',
table_rows_per_page: 'Records per page:',
table_separator: 'of',
table_all: 'All',
table_title: 'Title',
table_parent: 'Parent',
table_date: 'Date',
table_color: 'Colors',
table_state: 'Status',
table_actions: 'Actions',
table_empty: 'no results',
save: 'Save',
upload_image_error: 'Only jpg, jpeg and png files are allowed.\nMaximum size: 10MB.\n\n',
youtube_choose: 'Youtube',
upload_file_error: 'The file is larger than 10MB.',
editable_documents: 'Editable document',
pdf_documents: 'PDF Documents',
doc_choose: 'Upload document',
field_edit_responsable: 'Edition Responsible',
field_aproval_responsable: 'Approval Responsible',
field_remove_responsable: 'Removal Responsible',
field_choose_responsable: 'Choose a responsible',
field_document_state: 'Document status',
field_aproval: 'Approve',

notification_aproval_subject: 'Document approval request',
notification_aproval_text: 'You have a document approval request. Log in to the platform to follow up on the request.',

// Additional fields that might have been missing:
field_active_type: 'Repair Type',
field_active_type_placeholder: 'Enter the repair type',
field_equip_state: 'Equipment State',
field_equip_state_placeholder: 'Enter the equipment state',
field_details: 'Equipment Details',
field_codigo: 'Code',
field_identificacao: 'Identification',
field_marca: 'Brand',
field_modelo: 'Model',
field_numero_serie: 'Serial Number',
field_storage_fab_year: 'Manufacturing Year',
field_storage_supply: 'Supplier',
field_storage_serie: 'Series',
field_storage_serie_placeholder: 'Enter the Serial Number',
field_storage_location: 'Location',
field_storage_description: 'Description',
field_storage_date: 'Storage Date',
field_det_responsable: 'Detection Responsible',
field_det_responsable_date: 'Detection Date',
field_id: 'Equipment Code',
field_label: 'Equipment Label',
field_cod: 'Equipment Code',
field_brand: 'Equipment Brand',
field_model: 'Equipment Model',
field_serie: 'Equipment Serial Number',
field_local: 'Storage Location',
field_det_date: 'Detection Date',
problem_description: 'Problem Description',
problem_loc: 'Problem Location',
field_storage_brand: 'Brand',
field_storage_brand_placeholder: 'Enter the Brand',
field_storage_model: 'Model',
field_storage_model_placeholder: 'Enter the Model',
informacao_financeira: 'Financial Information',
ano_de_aquisicao: 'Acquisition Year',
ano_de_aquisicao_placeholder: 'Enter the acquisition year',
valor_de_aquisicao: 'Acquisition Value',
valor_de_aquisicao_placeholder: 'Enter the acquisition value',
data_fim_de_garantia: 'Warranty End Date',
data_fim_de_vida: 'End of Life Date',
tipo_manutencao: 'Maintenance Type',
field_data_inicio: 'Start Date',
field_deadline: 'Deadline'
    } ,
    "es":{
add_new: 'Solicitar Reparación',
cancel: 'Cancelar', back: 'Voltar',
component: 'Reparación',
component_new: 'Nueva Reparación',
component_edit: 'Editar Reparación',
component_list: 'Lista de Reparaciones',
close: 'Cerrar',
color: 'Color',
color_placeholder: 'Introduzca el color',
color_primary: 'Color Primario',
color_secondary: 'Color Secundario',
delete: 'Eliminar',
delete_title: 'Eliminar Registro',
delete_text: '¿Está seguro de que desea continuar?',
delete_confirm: 'Sí',
delete_cancel: 'No',
delete_error: '¡Problema al eliminar el registro!',
delete_success: '¡Registro eliminado con éxito!',
edit: 'Editar',
edit_title: 'Editar Registro',
edit_text: '¿Está seguro de que desea continuar?',
edit_confirm: 'Sí',
edit_cancel: 'No',
edit_error: '¡Problema al actualizar el registro!',
edit_success: '¡Registro actualizado con éxito!',

field_active_type: 'Tipo de Reparación',
field_active_type_placeholder: 'Introduzca el tipo de Reparación',
field_equip_state: 'Estado del Equipo',
field_equip_state_placeholder: 'Introduzca el estado del equipo',
field_activo: '¿Reparación?',
field_visivel: '¿Visible?',
field_avaiable: '¿Disponible?',
field_choose: 'Elija una opción',
field_category: 'Categoría',
field_category_placeholder: 'Introduzca la categoría',
field_observation: 'Observación',
field_observation_placeholder: 'Introduzca una observación',
field_abreviation: 'Abreviatura',
field_abreviation_placeholder: 'Introduzca la abreviatura',
field_adultos: 'Adultos',
field_adultos_placeholder: 'Introduzca el número de adultos',
field_criancas: 'Niños',
field_criancas_placeholder: 'Introduzca el número de niños',
field_description: 'Descripción',
field_description_placeholder: 'Introduzca la descripción',
field_forfait: 'Forfait',
field_forfait_price: 'Precio del Forfait',
field_forfait_price_placeholder: 'Introduzca el precio del Forfait',
field_forfait_taxe: 'IVA del Forfait',
field_forfait_taxe_placeholder: 'Introduzca el IVA del Forfait',
field_equipamento: 'Equipo',
field_equipamento_price: 'Precio del Equipo',
field_equipamento_price_placeholder: 'Introduzca el precio del Equipo',
field_equipamento_taxe: 'IVA del Equipo',
field_equipamento_taxe_placeholder: 'Introduzca el IVA del Equipo',
field_final_price: 'Precio Final',
field_final_price_palceholder: 'Introduzca el Precio Final',
field_price: 'Precio',
field_price_since: 'Precio desde',
field_name: 'Identificación del Equipo',
field_name_placeholder: 'Introduzca la Identificación del Equipo',
field_document_type: 'Tipo de Documento',
field_status: 'Estado',
field_comprimento: 'Longitud',
field_comprimento_placeholder: 'Inserir longitud',
field_dificuldade: 'Dificultad',
field_dificuldade_placeholder: 'Inserir dificultad',
field_desnivel: 'Desnivel (m)',
field_desnivel_placeholder: 'Inserir desnivel (m)',
field_type: 'Tipo',
field_duracao: 'Duración',
field_person: 'Asignación de técnicos',
field_appointment: 'Asignación de recursos',

field_tag: 'Código',
field_tag_placeholder: 'Inserir el código',
field_codigo: 'Código',
field_identificacao: 'Identificación',
field_marca: 'Marca',
field_modelo: 'Modelo',
field_numero_serie: 'Nº Serie',
field_storage_fab_year: 'Año de Fabricación',
field_storage_type: 'Formato de Almacenamiento',
field_storage_local: 'Local de Almacenamiento',
field_storage_supply: 'Proveedor',
field_storage_serie: 'Series',
field_storage_serie_placeholder: 'Introduzca el Número de Serie',
field_storage_location: 'Ubicación',
field_storage_description: 'Descripción',
field_storage_date: 'Fecha de Almacenamiento',
field_retention_time: 'Tiempo de retención',
field_state: 'Estado',
field_version: 'Versión',

field_det_responsable: 'Responsable Detección',
field_det_responsable_date: 'Fecha de Detección',
field_equipamento: 'Equipo',
field_details: 'Detalles del Equipo',
field_id: 'Código del Equipo',
field_label: 'Etiqueta del Equipo',
field_cod: 'Código del Equipo',
field_brand: 'Marca del Equipo',
field_model: 'Modelo del Equipo',
field_serie: 'Número de Serie del Equipo',
field_local: 'Local de Almacenamiento',
field_det_date: 'Fecha de Detección',
problem_description: 'Descripción del Problema',
problem_loc: 'Local del Problema',

field_aprovation_date: 'Fecha de aprobación',
field_aprovation_name: 'Nombre del responsable de la aprobación',
field_edition_date: 'Fecha de edición',
field_edition_name: 'Nombre del responsable de la edición',
field_storage_brand: 'Marca',
field_storage_brand_placeholder: 'Introduzca la Marca',
field_storage_model: 'Modelo',
field_storage_model_placeholder: 'Introduzca el Modelo',

foto: 'Foto',
upload_foto: 'Cargar Foto',
foto_empty: 'Sin Foto',
filter_placeholder: 'Buscar',
id: 'ID',
image: 'Imagen',
images: 'Imágenes',
image_choose: 'Elegir imagen',
insert_title: 'Nuevo Registro',
insert_text: '¿Está seguro de que desea continuar?',
insert_confirm: 'Sí',
insert_cancel: 'No',
insert_error: '¡Problema al insertar el registro!',
insert_success: '¡Registro insertado con éxito!',
principal: 'Principal',
remove: 'Eliminar',
table_rows_per_page: 'Registros por página:',
table_separator: 'de',
table_all: 'Todos',
table_title: 'Título',
table_parent: 'Parent',
table_date: 'Fecha',
table_color: 'Colores',
table_state: 'Estado',
table_actions: 'Acciones',
table_empty: 'sin resultados',
save: 'Guardar',
upload_image_error: 'Solo se permiten archivos jpg, jpeg y png.\nTamaño máximo: 10MB.\n\n',
youtube_choose: 'Youtube',
upload_file_error: 'El archivo tiene más de 10MB.',
editable_documents: 'Documento editable',
pdf_documents: 'Documentos PDF',
doc_choose: 'Cargar documento',
field_edit_responsable: 'Responsable de Edición',
field_aproval_responsable: 'Responsable de Aprobación',
field_remove_responsable: 'Responsable de Eliminación',
field_choose_responsable: 'Elija un responsable',
field_document_state: 'Estado del documento',
field_aproval: 'Aprobar',

notification_aproval_subject: 'Solicitud de aprobación de documento',
notification_aproval_text: 'Tiene una solicitud para aprobar un documento. Ingrese a la plataforma para dar seguimiento a la solicitud.',

informacao_financeira: 'Información Financiera',
ano_de_aquisicao: 'Año de Adquisición',
ano_de_aquisicao_placeholder: 'Introduzca el año de adquisición',
valor_de_aquisicao: 'Valor de Adquisición',
valor_de_aquisicao_placeholder: 'Introduzca el valor de adquisición',
data_fim_de_garantia: 'Fecha Fin de Garantía',
data_fim_de_vida: 'Fecha Fin de Vida',
tipo_manutencao: 'Tipo de Mantenimiento',
field_data_inicio: 'Fecha de Inicio',
field_deadline: 'Fecha Límite',
    },
    "fr":{
add_new: 'Demander Réparation',
cancel: 'Annuler',
component: 'Réparation',
component_new: 'Nouvelle Réparation',
component_edit: 'Modifier Réparation',
component_list: 'Liste des Réparations',
close: 'Fermer',
color: 'Couleur',
color_placeholder: 'Entrez la couleur',
color_primary: 'Couleur Primaire',
color_secondary: 'Couleur Secondaire',
delete: 'Supprimer',
delete_title: 'Supprimer Enregistrement',
delete_text: 'Êtes-vous sûr de vouloir continuer?',
delete_confirm: 'Oui',
delete_cancel: 'Non',
delete_error: 'Problème lors de la suppression de l\'enregistrement!',
delete_success: 'Enregistrement supprimé avec succès!',
edit: 'Modifier',
edit_title: 'Modifier Enregistrement',
edit_text: 'Êtes-vous sûr de vouloir continuer?',
edit_confirm: 'Oui',
edit_cancel: 'Non',
edit_error: 'Problème lors de la mise à jour de l\'enregistrement!',
edit_success: 'Enregistrement mis à jour avec succès!',

field_active_type: 'Type de Réparation',
field_active_type_placeholder: 'Entrez le type de Réparation',
field_equip_state: 'État de l\'Équipement',
field_equip_state_placeholder: 'Entrez l\'état de l\'équipement',
field_activo: 'Réparation?',
field_visivel: 'Visible?',
field_avaiable: 'Disponible?',
field_choose: 'Choisissez une option',
field_category: 'Catégorie',
field_category_placeholder: 'Entrez la catégorie',
field_observation: 'Observation',
field_observation_placeholder: 'Entrez une observation',
field_abreviation: 'Abréviation',
field_abreviation_placeholder: 'Entrez l\'abréviation',
field_adultos: 'Adultes',
field_adultos_placeholder: 'Entrez le nombre d\'adultes',
field_criancas: 'Enfants',
field_criancas_placeholder: 'Entrez le nombre d\'enfants',
field_description: 'Description',
field_description_placeholder: 'Entrez la description',
field_forfait: 'Forfait',
field_forfait_price: 'Prix du Forfait',
field_forfait_price_placeholder: 'Entrez le prix du Forfait',
field_forfait_taxe: 'TVA du Forfait',
field_forfait_taxe_placeholder: 'Entrez la TVA du Forfait',
field_equipamento: 'Équipement',
field_equipamento_price: 'Prix de l\'Équipement',
field_equipamento_price_placeholder: 'Entrez le prix de l\'Équipement',
field_equipamento_taxe: 'TVA de l\'Équipement',
field_equipamento_taxe_placeholder: 'Entrez la TVA de l\'Équipement',
field_final_price: 'Prix Final',
field_final_price_palceholder: 'Entrez le Prix Final',
field_price: 'Prix',
field_price_since: 'Prix depuis',
field_name: 'Identification de l\'Équipement',
field_name_placeholder: 'Entrez l\'Identification de l\'Équipement',
field_document_type: 'Type de Document',
field_status: 'État',
field_comprimento: 'Longueur',
field_comprimento_placeholder: 'Entrez la longueur',
field_dificuldade: 'Difficulté',
field_dificuldade_placeholder: 'Entrez la difficulté',
field_desnivel: 'Dénivelé (m)',
field_desnivel_placeholder: 'Entrez le dénivelé (m)',
field_type: 'Type',
field_duracao: 'Durée',
field_person: 'Affectation de techniciens',
field_appointment: 'Affectation de ressources',

field_tag: 'Code',
field_tag_placeholder: 'Entrez le code',
field_codigo: 'Code',
field_identificacao: 'Identification',
field_marca: 'Marque',
field_modelo: 'Modèle',
field_numero_serie: 'N° Série',
field_storage_fab_year: 'Année de Fabrication',
field_storage_type: 'Format de Stockage',
field_storage_local: 'Local de Stockage',
field_storage_supply: 'Fournisseur',
field_storage_serie: 'Séries',
field_storage_serie_placeholder: 'Entrez le Numéro de Série',
field_storage_location: 'Emplacement',
field_storage_description: 'Description',
field_storage_date: 'Date de Stockage',
field_retention_time: 'Temps de rétention',
field_state: 'État',
field_version: 'Version',

field_det_responsable: 'Responsable Détection',
field_det_responsable_date: 'Date de Détection',
field_equipamento: 'Équipement',
field_details: 'Détails de l\'Équipement',
field_id: 'Code de l\'Équipement',
field_label: 'Étiquette de l\'Équipement',
field_cod: 'Code de l\'Équipement',
field_brand: 'Marque de l\'Équipement',
field_model: 'Modèle de l\'Équipement',
field_serie: 'Numéro de Série de l\'Équipement',
field_local: 'Local de Stockage',
field_det_date: 'Date de Détection',
problem_description: 'Description du Problème',
problem_loc: 'Local du Problème',

field_aprovation_date: 'Date d\'approbation',
field_aprovation_name: 'Nom du responsable de l\'approbation',
field_edition_date: 'Date d\'édition',
field_edition_name: 'Nom du responsable de l\'édition',
field_storage_brand: 'Marque',
field_storage_brand_placeholder: 'Entrez la Marque',
field_storage_model: 'Modèle',
field_storage_model_placeholder: 'Entrez le Modèle',

foto: 'Photo',
upload_foto: 'Charger Photo',
foto_empty: 'Sans Photo',
filter_placeholder: 'Rechercher',
id: 'ID',
image: 'Image',
images: 'Images',
image_choose: 'Choisir image',
insert_title: 'Nouvel Enregistrement',
insert_text: 'Êtes-vous sûr de vouloir continuer?',
insert_confirm: 'Oui',
insert_cancel: 'Non',
insert_error: 'Problème lors de l\'insertion de l\'enregistrement!',
insert_success: 'Enregistrement inséré avec succès!',
principal: 'Principal',
remove: 'Supprimer',
table_rows_per_page: 'Enregistrements par page:',
table_separator: 'de',
table_all: 'Tous',
table_title: 'Titre',
table_parent: 'Parent',
table_date: 'Date',
table_color: 'Couleurs',
table_state: 'État',
table_actions: 'Actions',
table_empty: 'aucun résultat',
save: 'Enregistrer',
upload_image_error: 'Seuls les fichiers jpg, jpeg et png sont autorisés.\nTaille maximale: 10MB.\n\n',
youtube_choose: 'Youtube',
upload_file_error: 'Le fichier dépasse 10MB.',
editable_documents: 'Document éditable',
pdf_documents: 'Documents PDF',
doc_choose: 'Charger document',
field_edit_responsable: 'Responsable d\'Édition',
field_aproval_responsable: 'Responsable d\'Approval',
field_remove_responsable: 'Responsable de Suppression',
field_choose_responsable: 'Choisissez un responsable',
field_document_state: 'État du document',
field_aproval: 'Approuver',

notification_aproval_subject: 'Demande d\'approbation de document',
notification_aproval_text: 'Vous avez une demande d\'approbation de document. Connectez-vous à la plateforme pour suivre la demande.',

informacao_financeira: 'Information Financière',
ano_de_aquisicao: 'Année d\'Acquisition',
ano_de_aquisicao_placeholder: 'Entrez l\'année d\'acquisition',
valor_de_aquisicao: 'Valeur d\'Acquisition',
valor_de_aquisicao_placeholder: 'Entrez la valeur d\'acquisition',
data_fim_de_garantia: 'Date Fin de Garantie',
data_fim_de_vida: 'Date Fin de Vie',
tipo_manutencao: 'Type de Maintenance',
field_data_inicio: 'Date de Début',
field_deadline: 'Date Limite',
    }
}

module.exports = {
    language
};